import './i18n'

import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { ToastContainer } from 'react-toastify'

import { toastContainerSchema } from './@types/schemas/toast-containers'
import { SessionProvider } from './contexts/auth/session'
import { FeatureFlagsProvider } from './contexts/feature-flags/feature-flags-provider'
import { ThemeProvider } from './contexts/theme'
import { queryClient } from './queries'
import { AppRoutes } from './routes/index'

export function App() {
  return (
    <>
      <ToastContainer containerId={toastContainerSchema.Enum.GLOBAL} />

      <QueryClientProvider client={queryClient}>
        <ReactQueryDevtools initialIsOpen={false} />
        <SessionProvider>
          <FeatureFlagsProvider>
            <ThemeProvider defaultTheme="light" storageKey="@studio:theme">
              <AppRoutes />
            </ThemeProvider>
          </FeatureFlagsProvider>
        </SessionProvider>
      </QueryClientProvider>
    </>
  )
}
